export const unassigned = ({ assignee }) => assignee === '-';
export const assigned = ({ assignee }) => assignee !== '-';
